import { color } from '@magalu/stereo-ui-styles';
import styled from 'styled-components';
import { typography } from 'styled-system';
import { Image, Link as LinkComp } from '../../../../atoms';
export const Container = styled.div``;
const textColor = 'text.lightest';
export const Content = styled.div.attrs(props => Object.assign({
  color: textColor
}, props))`
  padding: 10px;
  ${color}
`;
export const Phone = styled.p.attrs(props => Object.assign({
  fontSize: 5
}, props))`
  margin-bottom: 10px;
  line-height: 24px;
  ${typography}
`;
export const OpeningHours = styled.p.attrs(props => Object.assign({
  fontSize: 0
}, props))`
  margin-bottom: 10px;
  ${typography}
`;
export const Links = styled.ul`
  list-style: none;
`;
export const LinkItem = styled.li`
  display: flex;
  margin-bottom: 20px;
`;
export const Link = styled(LinkComp).attrs(props => Object.assign({
  color: textColor,
  pl: 1
}, props))``;
export const SectionTitle = styled.p.attrs(props => Object.assign({
  color: textColor,
  fontSize: 1,
  fontWeight: 'regular'
}, props))`
  padding: 1rem 0 10px 0;
  ${color}
  ${typography}
`;
export const SocialLinks = styled.ul`
  list-style: none;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 0.7rem;
`;
export const LinkImage = styled(Image).attrs(props => Object.assign({
  minHeight: '35px'
}, props))`
  width: auto;
`;
export const SalesChannels = styled.div.attrs(props => Object.assign({}, props))`
  ${typography}
  margin-bottom: 10px;
`;
export const SaleChannel = styled.p.attrs(props => Object.assign({
  fontSize: 3,
  color: textColor
}, props))`
  svg {
    margin-right: 2px;
  }
  ${typography}
  display: flex;
  align-items: center;
`;